import { DropDownListPaginator } from '@design-system/components/templates/drop-down-list/entities/drop-down-list.types';

export function dropDownListPaginator(
  totalOfItems: number, currentPage: number, pageSize: number, maxPages: number
): DropDownListPaginator {
  const totalOfPages = Math.ceil(totalOfItems / pageSize);

  if (currentPage < 1) {
    currentPage = 1;
  } else if (currentPage > totalOfPages) {
    currentPage = totalOfPages;
  }

  let startPage: number, endPage: number;
  if (totalOfPages <= maxPages) {
    startPage = 1;
    endPage = totalOfPages;
  } else {
    const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
    const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      startPage = 1;
      endPage = maxPages;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalOfPages) {
      startPage = totalOfPages - maxPages + 1;
      endPage = totalOfPages;
    } else {
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize - 1, totalOfItems - 1);

  return {
    TotalOfItems: totalOfItems,
    TotalOfPages: totalOfPages,
    CurrentPage: currentPage,
    PageSize: pageSize,
    StartPage: startPage,
    EndPage: endPage,
    StartIndex: startIndex,
    EndIndex: endIndex,
    Pages: Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i),
  };
}
